import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toAbsoluteUrl } from '../../../utils/helpers';

export function Brand() {
    const { user } = useSelector((state: any) => state.auth);
    const [photoFailed, setPhotoFailed] = useState(false);
    const name = user?.displayName || `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
    const photo = user?.profilePhoto?.path ?? user?.profilePhoto?.thumbnail;
    const initials =
        `${user?.firstName?.[0] ?? ''}${user?.lastName?.[0] ?? ''}`.toUpperCase() || name[0]?.toUpperCase();

    return (
        <div className={`aside-brand d-flex flex-column align-items-center flex-column-auto py-5 py-lg-12`}>
            <Link to="" className="text-center">
                <img alt="logo" src={toAbsoluteUrl('/images/logo.jpeg')} style={{ width: '80%' }} />
            </Link>
            {user && (
                <OverlayTrigger placement="right" overlay={<Tooltip id="logged-user">{name}</Tooltip>}>
                    {photo && !photoFailed ? (
                        <img
                            alt={name}
                            src={photo}
                            onError={() => setPhotoFailed(true)}
                            className="rounded mt-6 border border-2 border-primary"
                            style={{ width: 40, height: 40, objectFit: 'cover' }}
                        />
                    ) : (
                        <span
                            className="rounded mt-6 border border-2 border-primary d-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                            style={{ width: 40, height: 40 }}
                        >
                            {initials}
                        </span>
                    )}
                </OverlayTrigger>
            )}
        </div>
    );
}
